// this is aliased in webpack config based on server/client build
import resource from '../resource'

export function fetchPrice (quantity, country, currency) {
  return resource.get("product_price?quantity="+quantity+"&country="+country+"&currency="+currency)
}




// WEBPACK FOOTER //
// ./lib/store/api.js